export const FRACAO_MULT: Record<string, number> = { un: 1, "1/2": 0.5, "1/4": 0.25, "1/8": 0.125 };
export const OPCOES_UN_UNIDADE = ["un", "1/2", "1/4", "1/8"];

const FRACOES_ORDEM: Array<{ fracao: string; fator: number }> = [
  { fracao: "1/2", fator: 0.5 },
  { fracao: "1/4", fator: 0.25 },
  { fracao: "1/8", fator: 0.125 },
];

export function inferirFracaoUn(qtdDecimal: number): { fracao: string; qtd: number } {
  const eps = 1e-6;
  if (Math.abs(qtdDecimal - Math.round(qtdDecimal)) < eps) {
    return { fracao: "un", qtd: Math.round(qtdDecimal) };
  }
  for (const { fracao, fator } of FRACOES_ORDEM) {
    const q = qtdDecimal / fator;
    if (qtdDecimal > 0 && Math.abs(q - Math.round(q)) < eps) {
      return { fracao, qtd: Math.round(q) };
    }
  }
  return { fracao: "un", qtd: qtdDecimal };
}

export function unidadeCanonicaParaBase(base: string): string {
  const b = base.trim().toLowerCase();
  if (b === "g" || b === "grama" || b === "gramas") return "g";
  if (b === "kg" || b === "quilo" || b === "quilograma" || b === "quilogramas") return "kg";
  if (b === "l" || b === "litro" || b === "litros") return "L";
  if (b === "ml" || b === "mililitro" || b === "mililitros") return "ml";
  if (b === "un" || b === "unidade") return "un";
  return base.trim() || "un";
}

export function opcoesUnidadePorBase(base: string): string[] {
  const b = base.trim().toLowerCase();
  if (b === "l" || b === "litro" || b === "litros") return ["L", "ml"];
  if (b === "ml" || b === "mililitro" || b === "mililitros") return ["ml", "L"];
  if (b === "kg" || b === "quilo" || b === "quilograma" || b === "quilogramas" || b === "g" || b === "grama" || b === "gramas") {
    return ["kg", "g"];
  }
  return OPCOES_UN_UNIDADE;
}

/** Converte quantidade para a unidade base do insumo (mesma lógica de entradas.php). */
export function converterParaBase(unidadeBase: string, unidadeComp: string, valor: number): number {
  const base = unidadeBase.trim().toLowerCase();
  const comp = unidadeComp.trim().toLowerCase();
  if (base === "un" || base === "unidade") {
    return valor;
  }
  if (base === "l" || base === "litro" || base === "litros") {
    if (comp === "ml" || comp === "mililitro" || comp === "mililitros") return valor / 1000;
    return valor;
  }
  if (base === "ml" || base === "mililitro" || base === "mililitros") {
    if (comp === "l" || comp === "litro" || comp === "litros") return valor * 1000;
    return valor;
  }
  if (base === "kg" || base === "quilo" || base === "quilograma" || base === "quilogramas") {
    if (comp === "g" || comp === "grama" || comp === "gramas" || comp === "gr") return valor / 1000;
    return valor;
  }
  if (base === "g" || base === "grama" || base === "gramas" || base === "gr" || base === "gram") {
    if (comp === "kg" || comp === "quilo" || comp === "quilograma" || comp === "quilogramas") return valor * 1000;
    return valor;
  }
  return valor;
}

export function normalizarUnidadeQuantidade(unidade: string, quantidade: number): [string, number] {
  const u = unidade.trim().toLowerCase();
  if (u === "1/2") return ["un", quantidade * 0.5];
  if (u === "1/4") return ["un", quantidade * 0.25];
  if (u === "1/8") return ["un", quantidade * 0.125];
  return [unidade, quantidade];
}
